"use client";

import React, { useState } from "react";

import * as Icon from "@phosphor-icons/react/dist/ssr";

interface Props {
  props: string;
}

const TopNavThree: React.FC<Props> = ({ props }) => {
  const [isOpenLanguage, setIsOpenLanguage] = useState(false);
  const [isOpenCurrence, setIsOpenCurrence] = useState(false);
  const [language, setLanguage] = useState("English");
  const [currence, setCurrence] = useState("USD");

  return (
    <>
      <div className={`top-nav z-5000 py-2 border-b border-line ${props}`}>
        <div className="w-[96%] mx-auto h-full">
          <div className="top-nav-main flex justify-between max-md:justify-center h-full">
            <div className="left-content flex items-center gap-6">
              <img
                src={require("../../../images/kissaria/njma 13.png")}
                alt="Kissaria"
                className="w-8 h-8"
              />
              <div className="flex items-center gap-3 text-pink">
                <Icon.Package className="font-bold text-lg" />
                <p className="font-semibold text-sm">
                  &lt; Achetez à l'unité et profitez d’une livraison le jour
                  même &gt;
                </p>
              </div>
            </div>
            <div className="right-content flex items-center gap-5 max-md:hidden">
              <div className="flex items-center gap-3 font-semibold text-pink">
                <Icon.PhoneCall className="text-lg" />
                <p className="text-sm">+212 520-065753</p>
              </div>
              <div className="flex items-center gap-3 font-semibold text-pink">
                <Icon.ChatCircle className="text-lg" />
                <p className="text-sm">+212 664-045333</p>
              </div>
              <img
                src={require("../../../images/kissaria/njma 13.png")}
                alt="Kissaria"
                className="w-8 h-8"
              />
              
              <div className="flex items-center gap-4">
                <a
                  className="text-pink"
                  href={"https://www.facebook.com/"}
                  target="_blank"
                >
                  <i className="icon-facebook text-pink"></i>
                </a>
                <a
                  className="text-pink"
                  href={"https://www.instagram.com/"}
                  target="_blank"
                >
                  <i className="icon-instagram text-pink"></i>
                </a>
                <a
                  className="text-pink"
                  href={"https://www.youtube.com/"}
                  target="_blank"
                >
                  <i className="icon-youtube text-pink"></i>
                </a>
                <a
                  className="text-pink"
                  href={"https://twitter.com/"}
                  target="_blank"
                >
                  <i className="icon-twitter text-pink"></i>
                </a>
                <a
                  className="text-pink"
                  href={"https://pinterest.com/"}
                  target="_blank"
                >
                  <i className="icon-pinterest text-pink"></i>
                </a>
              </div>
              <img
                src={require("../../../images/kissaria/njma 13.png")}
                alt="Kissaria"
                className="w-8 h-8"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopNavThree;
